<template>
  <div :class="{'container-dark': theme_dark}">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img">
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">账单</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="img/发布.png" class="nav-img none">
      </div>
    </div>

    <div class="menu-block">
      <li v-for="(item,index) in  arr" :key="index">
        <div class="menu-item ub ub-pc">
          <span class="item-coin">{{item.type == '增加' ? '+' : '-'}}{{item.amount}}</span>
          <span class="item-name ub ub-as ub-f1">{{item.type_dtl}}</span>
          <div class="item-date ub ub-ver ub-pc">
                <span>{{item.date}}</span>
                <span>{{item.time}}</span>
            </div>
        </div>
        <div v-if="index < arr.length-1" class="menu-line"></div>
      </li>

        <div class="ub ub-pc ub-ver no-data" v-if="arr.length <= 0">
        <img src="../../assets/img/暂无数据.png" class="no-data-img" />
        <div class="no-data-txt">暂无金币记录(ಥ_ಥ)</div>
      </div>
    </div>
    <div class="ub ub-pc ub-ac" v-if="arr.length > 0" >
      <div class="ub ub-ac ub-pc btn" @click="load_more()"><span>加载更多</span></div>
    </div>
    
  </div>
</template>

<script>
  import { mapMutations, mapActions } from "vuex";
  import * as tool from "../../api/common";
  export default {
    data() {
      return {
        arr: [],
        index:0,
        size:20,
        theme_dark: false
      };
    },

    mounted() {
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
      this.init_page();
    },
    methods: {
      ...mapMutations(['get', 'post']), //引入方法

      back() {
        this.$router.go(-1); //返回上一层
      },
      init_page() {
         this.load_more();
      },

      load_more(){
        this.$loading('加载...');

        var self = this;
        var uid = self.$store.state.uid;
        self.get({
            url: '/App/GetCoinData/?uid=' + uid + '&index=' + this.index + '&size=' +this.size,
            success: function (data_serve) {
              //console.log(JSON.stringify(data_serve));
              self.$loading.close();

              if(data_serve.length <= 0 && self.index>0){
                self.$toast.center("没有更多了~");
                return false;
              }

              // 处理每个数据对象，将日期和时间分开
              data_serve.forEach(function(item) {
                  if (item.dtm) {
                    var dtmParts = item.dtm.split(' ');
                    item.date = dtmParts[0];
                    item.time = dtmParts[1];
                  }
                  if (item.type_dtl.startsWith('newuser')) {
                    item.type_dtl = "萌新福利";
                  }
                });

              self.arr = self.arr.concat(data_serve) ;
              self.index++;
            },
            error: function (err) {
            
            }
          });

      }
    }
  };
</script>

<style lang="scss" scoped>
  .menu-block {
    padding: 0.2rem 0.8rem;
    background-color: #fff;
  }

  .menu-item {
    height: 3rem;
    justify-content: space-between;
    .item-coin {
      font-size: 1.5rem;
      display: inline-block;
      width: 6.75rem;
      color: red;
    }

    .item-name {
      font-size: 0.5rem;
      color: #929292;
    }

    .item-date {
      span {
          font-size: 0.75rem;
      }
    }
    .item-date span:nth-child(2) {
      margin-top: 0.5rem;
    }
  }

.no-data{
  padding: 5rem 0;
  .no-data-img {
    width: 9rem;
    height: 9rem;
  }
  .no-data-txt {
    margin-top: 1rem;
    color: #afafaf;
    margin-left: 0.5rem;
  }
}


.btn {
  margin: 1rem 0;
  padding: 0.5rem 8rem;
  border-radius: 2rem;
  background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
  span {
    font-size: 0.9rem;
    font-weight: bold;
    color: #FFFFFF;
  }
}

.menu-line {
  border-top: 1px solid #EFEFEF;
}

.container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
  .menu-block {
    background-color: #2c2b30;
    .menu-item {
      color: #DFDFDF;
    }
  }
  .menu-line {
    border-top: 1px solid #404040;
  }
}
</style>